// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1eLll","paymentContainer":"PaymentPage_paymentContainer__3pE5X"};